module.exports = "/_next/static/images/Safety-8b10c20e7eb2932e3f86b4720bd504fd.png";